import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\CreateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/CreateGravePlotController.php
* @route '/api/grave-plot'
*/
const CreateGravePlotController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateGravePlotController.url(options),
    method: 'post',
})

CreateGravePlotController.definition = {
    methods: ["post"],
    url: '/api/grave-plot',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\GravePlot\CreateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/CreateGravePlotController.php
* @route '/api/grave-plot'
*/
CreateGravePlotController.url = (options?: RouteQueryOptions) => {
    return CreateGravePlotController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\CreateGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/CreateGravePlotController.php
* @route '/api/grave-plot'
*/
CreateGravePlotController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateGravePlotController.url(options),
    method: 'post',
})

export default CreateGravePlotController